const ITEMS = [
  "Answers inbound calls",
  "Runs outbound campaigns",
  "Hindi · English · Bengali",
  "Follows the customer's language mid-call",
  "Full transcript on every call",
  "One versioned prompt per agent",
  "Disposition + recording + captured fields",
  "Humans work the queue",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-section" className="border-y border-zinc-200 bg-white py-5 overflow-hidden" aria-hidden="true">
      <div className="marquee-track">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8 whitespace-nowrap">
            <span className="font-display font-medium text-sm sm:text-base text-zinc-500">{item}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#2563EB]/60" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
